// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
//require("@rails/activestorage").start()

// Global libraries
global.$ = require('jquery')
global.toastr = require('toastr')
global.select2 = require('select2')
global.DataTables = require('datatables.net-bs4')
global.JSZip = require("jszip")
global.moment = require("moment")

// External non-rails libraries
require("jquery-slimscroll")
require("chart.js")
require("daterangepicker")
require("popper.js")
require("bootstrap")
require("admin-lte")
require("@fortawesome/fontawesome-free")
require("@nathanvda/cocoon")
require("select2/dist/js/i18n/pt-BR")

// Datatable dependencies
require("pdfmake")
require("datatables.net-rowgroup-bs4")
require("datatables.net-buttons-bs4")
require("datatables.net-buttons/js/buttons.colVis")
require("datatables.net-buttons/js/buttons.flash")
require("datatables.net-buttons/js/buttons.html5")
require("datatables.net-buttons/js/buttons.print")

// Custom packs
require("packs/config")
require("packs/main")
require("packs/inputmask")
require("packs/datetime-moment")
require("packs/vfs_fonts")
require("packs/toast_message")

// Channels
require("channels")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
